import api from '../../../services/api';

export type DocumentCenterType = 'PZ' | 'WZ' | 'SALES_INVOICE' | 'PURCHASE_INVOICE';

export interface DocumentCenterItem {
  id: string;
  type: DocumentCenterType;
  number: string;
  date?: string | null;
  orderId?: string | null;
  orderNumber?: string | null;
  /** Canonical operator-facing OMS number (manual number when active, raw otherwise). */
  displayOrderNumber?: string | null;
  clientOrderNumber?: string | null;
  customerName?: string | null;
  supplierName?: string | null;
  status?: string | null;
  amount?: number | string | null;
  currency?: string | null;
  sourcePath: string;
  pdfPath?: string | null;
  fileName?: string | null;
  createdAt?: string | null;
}

export interface FetchDocumentCenterParams {
  type?: DocumentCenterType;
  search?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
}

export async function fetchDocumentCenter(params: FetchDocumentCenterParams = {}): Promise<DocumentCenterItem[]> {
  const response = await api.get<DocumentCenterItem[]>('/document-center', { params });
  return response.data;
}

export async function downloadDocumentCenterPdf(pdfPath: string): Promise<Blob> {
  const apiPath = pdfPath.startsWith('/api') ? pdfPath.slice(4) : pdfPath;
  const response = await api.get(apiPath, { responseType: 'blob' });
  return response.data;
}
